import { render, staticRenderFns } from "./ticket-report.vue?vue&type=template&id=30240f91&"
import script from "./ticket-report.vue?vue&type=script&lang=js&"
export * from "./ticket-report.vue?vue&type=script&lang=js&"
import style0 from "./ticket-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports